export enum DeviceStatusEnum {
    ONLINE = 'Online',
    OFFLINE = 'Offline',
}